import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchAllRegions = async () => {
	const response =
		await cmsClient.get<CMSPaginatedData<Region>>("/store/region/");
	return response.data;
};
const useRegions = () => {
	const query = useQuery(["regions"], fetchAllRegions, { staleTime: 86400000 }); // 24 hour cache

	return query;
};

export default useRegions;
